import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
	RFQ_ROW_DATA,
	RFQ_LIST,
	QUOTATION_ROW_DATA,
	COMPARE_QUOTATION_ADD,
	COMPARE_QOUTATION_DATA,
	COMPARE_QOUTATION_LIST,
	GENERATE_PURCHASE_ORDER,
	PURCHASE_ORDER_LIST,
	FILTERS_SHOW_RIGHT_SIDEBAR,
	FILTERS_HIDE_RIGHT_SIDEBAR,
} from "./actionTypes";
import {
	apiError,
	getRFQListSuccessful,
	getRFQRequestdataSuccessful,
	getQuotationsData,
	getRFQRequestdata,
	gettQuotationsDataSuccessful,
	CompareQuotationDatasuccessfull,
	CompareQuotationListSuccessful,
	GetPurchaseOrderList,
	GetPurchaseOrderListSucces,
	GeneratePurchaseOrderResponse,
} from "./actions";

import {
	postAdd,
	getList,
	getParamsList,
	postEdit,
	// postDelete,
} from "../../helpers/Helper";
import swal from "sweetalert";

function* getRFQList() {
	try {
		const response = yield call(
			getList,
			"/requestforquotation/CompareQuotation/list",
			{}
		);
		// console.log(response, "CompareQuotation/list");
		yield put(getRFQListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getRFQRowdata({ payload: { rfqId } }) {
	try {
		const response = yield call(
			getList,
			"/requestforquotation/" + rfqId,
			{}
		);
		// console.log(response, "requestforquotation");
		yield put(getRFQRequestdataSuccessful(response));
		yield put(getQuotationsData(rfqId));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getQuotationRowdata({ payload: { rfqId } }) {
	try {
		const response = yield call(
			getList,
			"/quotation/quotationsbyrfq/" + rfqId,
			{}
		);
		// console.log(response, "/quotation/quotationsbyrfq/");
		yield put(gettQuotationsDataSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}

function* AddCompareQoutation({ payload: { data, cqId, history } }) {
	try {
		if (cqId === "0") {
			const response = yield call(postAdd, "/comparequotation/", data);
			if (response.status === 201) {
				swal("Poof! Your Compare Cuotation Added Successfully.!", {
					icon: "success",
				});
				history.push("/CompareQuotationDashboard");
			} else {
				swal(
					"Sorry! Unable to add Compare Quotation. Please Try Again!",
					{
						icon: "error",
					}
				);
			}
		} else {
			const response = yield call(
				postEdit,
				"/comparequotation/" + cqId,
				data
			);
			if (response.status === 200) {
				swal("Poof! Your Compare Quotation Edited Successfully.!", {
					icon: "success",
				});
				history.push("/CompareQuotationDashboard");
			} else {
				swal(
					"Sorry! Unable to edit Compare Quotation. Please Try Again!",
					{
						icon: "error",
					}
				);
			}
		}
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getCompareQuotationRowdata({ payload: { cqId } }) {
	try {
		const response = yield call(getList, "/comparequotation/" + cqId, {});
		// console.log(response, "comparequotations");
		yield put(CompareQuotationDatasuccessfull(response));
		yield put(getRFQRequestdata(response.requestforquotation));
		yield put(GetPurchaseOrderList(response.requestforquotation));
		//
	} catch (error) {
		yield put(apiError(error));
	}
}
function* getCompareQuotationList({ payload: { data } }) {
	var params = {};
	for (const k in data) {
		if (Object.hasOwnProperty.call(data, k)) {
			if (k === "currentSort" || k === "sortOrder") {
				params.ordering = data.sortOrder + data.currentSort;
			} else {
				if (data[k] !== "") {
					params[k] = data[k];
				}
			}
		}
	}
	try {
		const response = yield call(
			getParamsList,
			"/comparequotation/list",
			params
		);
		// console.log(response, "comparequotationslist");

		yield put(CompareQuotationListSuccessful(response));
	} catch (error) {
		yield put(apiError(error));
	}
}
function* GeneratePurchaseOrder({ payload: { data } }) {
	try {
		yield put(GeneratePurchaseOrderResponse(data, 1, true));
		const response = yield call(postAdd, "/purchaseorder/", data);
		if (response.status === 201) {
			yield put(GeneratePurchaseOrderResponse(data, 2, false));
		} else {
			yield put(GeneratePurchaseOrderResponse(data, 3, false));
		}
	} catch (error) {
		yield put(GeneratePurchaseOrderResponse(data, 3, false));
	}
}
function* PurchaseOrderList({ payload: { rfqId } }) {
	try {
		const response = yield call(
			getList,
			"/purchaseorder/pobyrfq/" + rfqId,
			{}
		);
		// console.log(response, "purchaseorder/pobyrfq/");
		yield put(GetPurchaseOrderListSucces(response));

		//
	} catch (error) {
		yield put(apiError(error));
	}
}
/**
 * CProduct the class on body
 * @param {*} cssClass
 */
function manageBodyClass(cssClass, action = "toggle") {
	switch (action) {
		case "add":
			if (document.body) document.body.classList.add(cssClass);
			break;
		case "remove":
			if (document.body) document.body.classList.remove(cssClass);
			break;
		default:
			if (document.body) document.body.classList.toggle(cssClass);
			break;
	}

	return true;
}
function* FilterShowRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled");
	} catch (error) {}
}
function* FilterHideRightSidebar() {
	try {
		yield call(manageBodyClass, "filters-right-bar-enabled", "remove");
	} catch (error) {}
}
export function* watchgetRFQList() {
	yield takeEvery(RFQ_LIST, getRFQList);
}
export function* watchgetRFQRowdata() {
	yield takeEvery(RFQ_ROW_DATA, getRFQRowdata);
}
export function* watchgetQuotationRowdata() {
	yield takeEvery(QUOTATION_ROW_DATA, getQuotationRowdata);
}
export function* watchCompareQoutationAdd() {
	yield takeEvery(COMPARE_QUOTATION_ADD, AddCompareQoutation);
}
export function* watchCompareQuotationData() {
	yield takeEvery(COMPARE_QOUTATION_DATA, getCompareQuotationRowdata);
}
export function* watchgetCompareQuotationList() {
	yield takeEvery(COMPARE_QOUTATION_LIST, getCompareQuotationList);
}
export function* watchPurchaseOrderList() {
	yield takeEvery(PURCHASE_ORDER_LIST, PurchaseOrderList);
}
export function* watchGeneratePurchaseOrder() {
	yield takeEvery(GENERATE_PURCHASE_ORDER, GeneratePurchaseOrder);
}
export function* watchFilterShowRightSidebar() {
	yield takeEvery(FILTERS_SHOW_RIGHT_SIDEBAR, FilterShowRightSidebar);
}
export function* watchfilterHideRightSidebarr() {
	yield takeEvery(FILTERS_HIDE_RIGHT_SIDEBAR, FilterHideRightSidebar);
}
function* CompareQuotationSaga() {
	yield all([
		fork(watchgetRFQList),
		fork(watchgetRFQRowdata),
		fork(watchgetQuotationRowdata),
		fork(watchCompareQoutationAdd),
		fork(watchCompareQuotationData),
		fork(watchgetCompareQuotationList),
		fork(watchPurchaseOrderList),
		fork(watchGeneratePurchaseOrder),
		fork(watchFilterShowRightSidebar),
		fork(watchfilterHideRightSidebarr),
	]);
}

export default CompareQuotationSaga;
